//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import DatasetLogDetail from '@/modules/tasks/powerbi/components/DatasetLogDetail';
import ReportGdsLogDetail from '@/modules/tasks/datastudio/components/ReportGdsLogDetail';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import BaseLoading from '@/components/BaseLoading';
export default {
  name: 'TabHistoryLogView',
  components: {
    BaseLoading: BaseLoading,
    DatasetLogDetail: DatasetLogDetail,
    ReportGdsLogDetail: ReportGdsLogDetail
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    typeObject: {
      type: String,
      default: 'datasource'
    }
  },
  created: function created() {
    this.onLoadTable();
  },
  data: function data() {
    return {
      items: [],
      fields: [{
        key: 'created_by',
        label: 'Applicant',
        class: 'w-15'
      }, {
        key: 'type',
        label: 'Log Type',
        class: 'w-10'
      }, {
        key: 'tableau_datasource',
        label: 'Description'
      }, {
        key: 'updated_date',
        label: 'Created',
        class: 'w-10'
      }, {
        key: 'response',
        label: 'Response',
        class: 'w-10'
      }],
      isLoading: false,
      headers: [{
        value: 'created_by',
        text: this.traductor('my_tasks.tablas_tasks.applicant'),
        class: 'w-15'
      }, {
        value: 'type',
        text: this.traductor('my_tasks.modals.log_type'),
        class: 'w-10'
      }, {
        value: 'tableau_datasource',
        text: this.traductor('my_tasks.modals.description')
      }, {
        value: 'updated_date',
        text: this.traductor('my_tasks.tablas_tasks.creation_date'),
        class: 'w-10'
      }, {
        value: 'response',
        text: this.traductor('my_tasks.modals.response'),
        class: 'w-10'
      }]
    };
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onLoadTable: function onLoadTable() {
      var _this = this;
      var userInfo = window.userInfo;
      if (this.typeObject === 'datasource') {
        this.fields = [{
          key: 'created_by',
          label: 'Applicant',
          class: 'w-15'
        }, {
          key: 'type',
          label: 'Log Type',
          class: 'w-10'
        }, {
          key: 'tableau_datasource',
          label: 'Description'
        }, {
          key: 'updated_date',
          label: 'Created',
          class: 'w-10'
        }, {
          key: 'response',
          label: 'Response',
          class: 'w-10'
        }];
        var data = {
          domain: userInfo.domain,
          clauses: {
            document_id: this.item.id
          }
        };
        this.items = [];
        TableauDatasourceService.tableauDataSourceLogQuery(data).then(function (res) {
          if (res.code === 200) {
            _this.items = res.data.result;
          }
        });
      } else if (this.typeObject === 'workbook') {
        this.fields = [{
          key: 'created_by',
          label: 'Applicant',
          class: 'w-15'
        }, {
          key: 'type',
          label: 'Log Type',
          class: 'w-10'
        }, {
          key: 'tableau_workbook',
          label: 'Description'
        }, {
          key: 'updated_date',
          label: 'Created',
          class: 'w-10'
        }, {
          key: 'response',
          label: 'Response',
          class: 'w-10'
        }];
        var _data = {
          domain: userInfo.domain,
          clauses: {
            document_id: this.item.id
          }
        };
        this.items = [];
        TableauDashboardService.tableauWorkBookLogQuery(_data).then(function (res) {
          if (res.code === 200) {
            _this.items = res.data.result;
          }
        });
      } else if (this.typeObject == 'dataset') {
        this.isLoading = true;
        this.fields = [{
          key: 'created_by',
          label: 'Applicant',
          class: 'w-15'
        }, {
          key: 'type',
          label: 'Log Type',
          class: 'w-10'
        }, {
          key: 'powerbi_dataset',
          label: 'Description'
        }, {
          key: 'updated_date',
          label: 'Created',
          class: 'w-10'
        }, {
          key: 'response',
          label: 'Response',
          class: 'w-10'
        }];
        var _data2 = {
          domain: userInfo.domain,
          clauses: {
            document_id: this.item.dataset_id
          }
        };
        this.items = [];
        BiDatasetService.datasetLogQuery(_data2).then(function (res) {
          if (res.code === 200) {
            _this.items = res.data.result;
          }
        }).finally(function () {
          _this.isLoading = false;
        });
      } else if (this.typeObject == 'report') {
        this.fields = [{
          key: 'created_by',
          label: 'Applicant',
          class: 'w-15'
        }, {
          key: 'type',
          label: 'Log Type',
          class: 'w-10'
        }, {
          key: 'powerbi_report',
          label: 'Description'
        }, {
          key: 'updated_date',
          label: 'Created',
          class: 'w-10'
        }, {
          key: 'response',
          label: 'Response',
          class: 'w-10'
        }];
        var _data3 = {
          domain: userInfo.domain,
          clauses: {
            document_id: this.item.dataset_id
          }
        };
        this.items = [];
        this.isLoading = true;
        BiReportService.reportLogQuery(_data3).then(function (res) {
          if (res.code === 200) {
            _this.items = res.data.result;
          }
        }).finally(function () {
          _this.isLoading = false;
        });
      } else if (this.typeObject == 'report_gds') {
        this.fields = [{
          key: 'created_by',
          label: 'Applicant',
          class: 'w-15'
        }, {
          key: 'type',
          label: 'Log Type',
          class: 'w-10'
        }, {
          key: 'datastudio_report',
          label: 'Description'
        }, {
          key: 'updated_date',
          label: 'Created',
          class: 'w-10'
        }, {
          key: 'response',
          label: 'Response',
          class: 'w-10'
        }];
        if (this.item.report_id) {
          var _data4 = {
            domain: userInfo.domain,
            clauses: {
              document_id: this.item.report_id
            }
          };
          this.items = [];
          DatastudioReportService.reportLogQuery(_data4).then(function (res) {
            if (res.code === 200) {
              _this.items = res.data.result;
            }
          });
        }
      }
    }
  }
};